import { createContext } from 'react';

export const VisibilityModalContext = createContext<{
  showVisibilityModal: boolean;
  setShowVisibilityModal?: (show: boolean) => void;
}>({
  showVisibilityModal: false,
});
